<template>
    <div class="row px-2 pb-1">
        <div class="col-12 bg-greige">
            <div class="row">
                <div class="col-12 col-lg-7 py-1">
                    <div class="bg-greige d-flex align-items-center">
                        <div
                            class="alert-icon text-primary font-size-28 me-1"
                            :class="['icon', dto.icon]"
                            aria-hidden="true"
                        />
                        <div>
                            <div class="ob1-alert-title fw-bold">{{ dto.title }}</div>
                            <div class="ob1-alert-title">{{ dto.text }}</div>
                        </div>
                    </div>
                </div>
                <div
                    v-if="dto.promoteLink"
                    class="col-12 col-lg-5 d-flex align-items-center justify-content-lg-end text-lg-end ps-4 ps-lg-0"
                >
                    <a
                        v-if="!dto.remiseInternetPopinComponent"
                        class="ob1-link-arrow"
                        :href="dto.promoteLink.url"
                        :data-oevent-category="dto.promoteLink.tms.category"
                        :data-oevent-action="dto.promoteLink.tms.action"
                        :data-oevent-label="dto.promoteLink.tms.label"
                        v-text="dto.promoteLink.label"
                    />
                    <button
                        v-else
                        type="button"
                        class="ob1-link-arrow"
                        data-bs-toggle="modal"
                        :data-bs-target="dto.promoteLink.url"
                        :data-oevent-category="dto.promoteLink.tms.category"
                        :data-oevent-action="dto.promoteLink.tms.action"
                        :data-oevent-label="dto.promoteLink.tms.label"
                        v-text="dto.promoteLink.label"
                    />
                </div>
            </div>
        </div>
        <div v-if="dto.remiseInternetPopinComponent">
            <InternetDiscountPopinShared
                v-if="dto.remiseInternetPopinComponent"
                ref="remiseInternetPopin"
                :id="'remise-open-modal'"
                :dto="dto.remiseInternetPopinComponent"
                mode="cart"
                @sponsor-success="$emit('sponsor-success', $event)"
            />
        </div>
    </div>
</template>

<script>
import InternetDiscountPopinShared from "../../components/sponsor/InternetDiscountPopinShared.vue";

export default {
    name: 'CartPageAdditionalAcquisition',
    components: {InternetDiscountPopinShared},
    props: {
        dto: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style scoped lang="scss">
@import 'ob1_common';

.icon.text-gray3 {
    font-size: 40px;
}

.icon.text-primary {
    font-size: 30px;
}
</style>
